import { render, staticRenderFns } from "./Cchxpcrksj.vue?vue&type=template&id=4406748f&scoped=true&"
import script from "./Cchxpcrksj.vue?vue&type=script&lang=js&"
export * from "./Cchxpcrksj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406748f",
  null
  
)

export default component.exports